// const config = {
//     API_URL: function(){
//         let live = 'http://13.49.154.94/backend';
//         // let live = 'http://139.59.35.110/castclass';
//         // http://13.49.154.94/backend/api/v2/
//         // let local = 'http://localhost/castclass';
//         return live+'/api/v2/';
//     }
// }

const config = {
    API_URL: function(){
       // let live = 'http://13.49.154.94/backend';
        // let live = 'http://139.59.35.110/castclass';
        // http://13.49.154.94/backend/api/v2/
        // let local = 'http://localhost/castclass';
        //return live+'/api/v2/';

        let live = 'https://staging.castclass.webgarh.net/';
        return live + 'api/';
    }
}

export default config;